import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { user, workspace } from "recoil/recoilState";

export default function Init() {
  const userInfo = useRecoilValue(user);
  const workspaceInfo = useRecoilValue(workspace);
  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo?.id) {
      if (workspaceInfo?.id) {
        if (workspaceInfo.mileVisitorsUsage) navigate("/visitors/나의%20방문%20관리");
        else if (workspaceInfo.mileMeetingsUsage) navigate("/meeting/예약%20현황");
      } else navigate(`/workspace/list`);
    }
  }, [userInfo, workspaceInfo]);

  return <></>;
}
